<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Update Platform" @show="setUpdateData" @hide="closeModal()">
    <b-card>
      <b-row>
        <b-col sm="6">
          <p-input v-model="form.name" label="Display Name" name="name" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="3">
          <p-input v-model="form.order" label="Order" name="order" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="3">
          <p-input v-model="form.action" label="Action" name="action" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="6">
          <p-image v-model="form.icon" label="Platform Icon" name="icon" :handler="$v" :formData="form" class="platform-image" />
        </b-col>
        <template v-for="(x) in imageField">
          <b-col sm="6" :key="x">
            <p-image v-model="form[x]" :label="getLabel(x)" :name="x" :handler="$v" :formData="form" class="platform-image"/>
          </b-col>
        </template>
        <b-col sm="6">
          <p-switch v-model="form.status" label="Status" name="status" :handler="$v" :formData="form"/>
        </b-col>
        <b-col sm="6">
          <label>Available Game Type</label><br/>
          <b-badge v-for="val in gameKind" variant="primary" :key="val" class="mx-1">{{ val }}</b-badge>&nbsp;&nbsp;
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-btn variant="success" @click="submit()">Save</b-btn>
          <b-btn variant="danger" @click="closeModal()">Cancel</b-btn>
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput, PSwitch, PImage } from '../../../components'

export default {
  name: 'UpdateModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: () => {}
    },
    imageField: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      gameKind: [],
      form: {
        name: '',
        code: '',
        status: 0,
        order: '',
        action: '',
        icon: ''
      }
    }
  },
  validations: {
    form: {
      name: {required},
      code: {required},
      status: {required},
      order: {required},
      action: {},
      icon: {required}
    }
  },
  components: {
    PInput,
    PSwitch,
    PImage
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  methods: {
    getLabel (label) {
      let l = label.charAt(0).toUpperCase() + label.slice(1) + 'Image'
      return l.replace(/([A-Z])/g, ' $1').trim()
    },
    setUpdateData () {
      this.gameKind = this.updateData.GameKind.split(',')
      this.form.code = this.updateData.Code
      this.form.name = this.updateData.DisplayName || this.updateData.Code
      this.form.status = this.updateData.Status
      this.form.order = this.updateData.Order
      this.form.action = this.updateData.Action
      this.form.icon = this.updateData.IconImage
      this.imageField.forEach(x => {
        this.form[x] = this.updateData[x.charAt(0).toUpperCase() + x.slice(1) + 'Image']
        this.$v.form[x] = {}
      })
    },
    async submit () {
      try {
        Events.$emit('loader')
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        let formData = new FormData()
        formData.append('code', this.form.code)
        formData.append('name', this.form.name)
        formData.append('status', this.form.status)
        formData.append('order', this.form.order)
        formData.append('action', this.form.action)
        formData.append('icon', this.form.icon)
        this.imageField.forEach(x => {
          formData.append(x, this.form[x])
        })
        await this.$http.post(this.API_ENDPOINT + '/game/v2/platform/update', formData, { headers: { 'Content-Type': 'application/json' } })
        this.closeModal()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    closeModal () {
      this.$v.form.$reset()
      this.$emit('closeModal')
    }
  }
}
</script>


<style >
.image-preview {
  filter: drop-shadow(2px 4px 6px black);
}
</style>



// WEBPACK FOOTER //
// src/views/game/platforms/Update.vue